'use es6';

import { Record } from 'immutable';
export default Record({
  network: null,
  id: null
});